document.addEventListener("DOMContentLoaded", function () {
  // Function to initialize a slider
  function initializeSlider(selector, options) {
    const element = document.querySelector(selector);
    if (element) {
      return new Flickity(element, options);
    }
    return null;
  }

  // Initialize press quote slider
  const flktyPressQuote = initializeSlider('.press-quote-slider', {
    wrapAround: true,
    autoPlay: 6000,
    fade: true,
    draggable: true,
    prevNextButtons: false,
    pageDots: false,
    setGallerySize: true
  });

  // Initialize press logo slider
  const flktyPressLogo = initializeSlider('.press-logo-slider', {
    asNavFor: '.press-quote-slider',
    prevNextButtons: false,
    contain: true,
    pageDots: false,
    imagesLoaded: true
  });

  // Function to resize sliders
  function resizeSliders() {
    if (flktyPressQuote) flktyPressQuote.resize();
    if (flktyPressLogo) flktyPressLogo.resize();
  }

  // Resize event listener
  window.addEventListener('resize', resizeSliders);

  // Initial resize call
  resizeSliders();
});